import * as Yup from 'yup';
import { isFutureDate } from './validationHelpers';

const baseVehicleSchema = Yup.object().shape({
  vin: Yup.string()
    .required('VIN Number is required')
    .matches(/^[A-HJ-NPR-Z0-9]{17}$/, 'VIN must be 17 characters (no I, O, Q)'),
  make: Yup.string()
    .required('Make is required')
    .max(50, 'Make should not exceed 50 characters'),
  model: Yup.string()
    .required('Model is required')
    .max(50, 'Model should not exceed 50 characters'),
  model_year: Yup.number()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .typeError('Year must be a valid number')
    .required('Year is required')
    .min(2016, 'Year must be 2016 or later')
    .max(new Date().getFullYear(), `Year cannot be later than ${new Date().getFullYear()}`),
  mileage: Yup.number()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .typeError('Mileage must be a valid number')
    .required('Mileage is required')
    .positive('Mileage must be a positive number'),
});

const baseLoanSchema = Yup.object().shape({
  current_monthly_payment: Yup.string().required('Monthly Loan Payment is required'),
  current_payoff: Yup.string().required('Remaining Loan is required'),
  next_payment_date: Yup.date()
  .transform((value, originalValue) => (originalValue === '' ? undefined : value))
  .when('lien_holder', {
    is: (val) => val && val.trim() !== '',
    then: (schema) =>
      schema
        .typeError('Please enter a valid date')
        .required('Next Payment Date is required'),
    otherwise: (schema) =>
      schema
        .nullable()
        .typeError('Please enter a valid date'),
  }),
  lien_holder: Yup.string()
    .required('Current Lender is required')
    .max(30, 'Current Lender should not exceed 30 characters'),
});


export const stepFiveSchema = Yup.object().shape({
  vin: baseVehicleSchema.fields.vin,
  make: baseVehicleSchema.fields.make,
  model: baseVehicleSchema.fields.model,
  model_year: baseVehicleSchema.fields.model_year,
  mileage: baseVehicleSchema.fields.mileage,
  current_monthly_payment: baseLoanSchema.fields.current_monthly_payment,
  current_payoff: baseLoanSchema.fields.current_payoff,
  next_payment_date: baseLoanSchema.fields.next_payment_date,
  lien_holder: baseLoanSchema.fields.lien_holder,
  comments: Yup.string(),

  //  NEW: Validation for additional entries
  additional_vehicles: Yup.array().of(baseVehicleSchema),
  additional_loans: Yup.array().of(baseLoanSchema),
});
